
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import CONSTANTS from '../../constants';


class SummarySectionBlock extends PureComponent {
  _isMounted = false;
  static defaultProps = {
    fold: true,
    opened: false,
    description: "",
  };
  constructor(props) {
    super(props);
    this.state = {
      pageLoaded: false,
      showBody: this.props.opened,
    };
  }
  componentWillMount() {
    this._isMounted = true;
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }




  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {
    const classes = (this.state.showBody ? '' : ' closed');
    const noBackgroudColorClasse = (this.props.title == CONSTANTS.LABELS.summary_comment && CONSTANTS.SITE_INFO.BRAND_CODE == 'V' ? 'no-background-color' : '');
    return (

      <div className={`summary-section-block__wrapper ${classes + this.props.className}`}>
        <div className={`summary-section-block__header ${noBackgroudColorClasse}`} onClick={(e) => {
          if (window.isMobile() != 'desktop' && this.props.fold)
            this.setState({ showBody: (this.state.showBody ? false : true) })
        }}>

          <p tabIndex="0" className="header-title">{this.props.title}

            {this.props.description.length > 0 && <span>{this.props.description}</span>}

          </p>
          {this.props.fold && <div
            className="fold-button"
            tabIndex='0'
            onKeyDown={(e) => e.key === 'Enter' && this.setState({ showBody: (this.state.showBody ? false : true) })}
            onClick={(e) => this.setState({ showBody: (this.state.showBody ? false : true) })}
          >
            <span className="fold-title">{CONSTANTS.LABELS.common_v2_detail}</span>
            <i className={`mark-icons arrowNav-icon ${classes}`}></i>
          </div>}
        </div>
        {this.state.showBody && <div className="summary-section-block__body">
          {this.props.children}
        </div>}
      </div>
    );
  }
}
export default SummarySectionBlock;
